import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getIsJourneyNewUserEntrySourceEnabled } from 'modules/workflows/ducks';
import { Checkbox } from 'ui/checkboxV2';
import { spacing } from 'ui/theme';
import { useStartNodeContext } from '../StartNodeEditor.context';

const StyledCheckbox = styled(Checkbox)`
  margin-top: ${spacing.threeQuarter};
  align-items: flex-start;

  label {
    width: 85%;
  }
`;

export const CREATION_ONLY_CHECKBOX_TEST_ID = 'creation-only-checkbox';

export const CreationOnlyCheckbox = () => {
  const isJourneyNewUserEntrySourceEnabled = useSelector(getIsJourneyNewUserEntrySourceEnabled);
  const { nodeData, setNodeData, isReadOnly } = useStartNodeContext();
  const { onNewUserCreation = false } = nodeData;

  if (!isJourneyNewUserEntrySourceEnabled) return null;
  return (
    <StyledCheckbox
      data-test={CREATION_ONLY_CHECKBOX_TEST_ID}
      label={<>Also add users when their user profile is first created</>}
      status={onNewUserCreation}
      setChecked={() => setNodeData({ onNewUserCreation: !onNewUserCreation })}
      isDisabled={isReadOnly}
    />
  );
};
